@if (readonly()) {
    <!-- Lixeira e favoritos: só o que tem descrição mostra o viewer. -->
    @if (hasDescription()) {
        <inline-text-editor [field]="field()" target="description" [readonly]="true" />
    }
} @else {
    <!-- A descrição é editada direto no card; vazia, o placeholder é o convite. -->
    <inline-text-editor
        [field]="field()"
        target="description"
        [placeholder]="'document.edit.cardBase.addDescription' | translate"
        [blocked]="blocked()" />
}
